import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserManagementRoutingModule } from './user-management-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, UserManagementRoutingModule],
})
export class UserManagementModule {}
